var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoicesTableDefaultBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 977,
    height: 524,
    viewBox: "0 0 977 524",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.1845,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(-0.96207 0.272803 0.272803 0.96207 444.708 289.992)",
    fill: "#86AAB4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.1845,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(-0.96207 0.272803 0.272803 0.96207 966.479 244.774)",
    fill: "#86AAB4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.1845,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(-0.96207 0.272803 0.272803 0.96207 33.85 244.774)",
    fill: "#86AAB4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 279.277,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(-0.96207 0.272803 0.272803 0.96207 483.643 203.522)",
    fill: "#5D7C84"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.1845,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(-0.96207 0.272803 0.272803 0.96207 248.809 270.112)",
    fill: "#86AAB4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 234.905,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(-0.96207 0.272803 0.272803 0.96207 364.35 155.063)",
    fill: "#435E64"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 288.073,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(-0.96207 0.272803 0.272803 0.96207 369.527 311.981)",
    fill: "#435E64"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 255.679,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(-0.96207 0.272803 0.272803 0.96207 887.441 164.449)",
    fill: "#435E64"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180.32,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(-0.96207 0.272803 0.272803 0.96207 675.312 224.6)",
    fill: "#5D7C84"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.1845,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(-0.96207 0.272803 0.272803 0.96207 675.312 224.6)",
    fill: "#86AAB4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicesTableDefaultBg);
export default __webpack_public_path__ + "static/media/invoices-table-default-bg.fdede9349ac290de8f4b55d3ec8e1d8e.svg";
export { ForwardRef as ReactComponent };